import React from "react";
import { Button, Image, Space } from "antd";
import AvatarDefault from "@assets/images/ava.svg";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import moment from "moment";
import { PACKAGE_CYCLE } from "@pages/AccountPage/components/AccountSubscription";
import { ModalChoosePack } from "@components/Modal";

const UserBlock = ({ user, currentPack }) => {
  const { t } = useTranslation();
  const [displayModal, setDisplayModal] = React.useState(false);

  const packagePack = currentPack?.filter((pack) => pack?.type === 1)?.[0];
  const isExpired =
    packagePack?.pack_id &&
    moment(packagePack?.next_charge_time).isBefore(moment());
  const extraBidTotal = currentPack
    ?.filter((pack) => pack?.type !== 1)
    ?.reduce((acc, pack) => {
      return acc + pack?.turn;
    }, 0);
  const bidTotal = currentPack?.reduce((acc, pack) => {
    return acc + pack?.turn;
  }, 0);
  const packagePackLength = currentPack?.filter((pack) => pack?.type === 1);

  const handleModal = () => {
    setDisplayModal(true);
  };

  const handleClose = () => setDisplayModal(false);

  return (
    <>
      <div className="user-block">
        <Space
          className="user-block-wrapper"
          align="center"
          size={[8, 8]}
          style={{ width: "100%" }}>
          <Link to={PATHS.ACCOUNT_PAGE} className="user-image">
            <Image
              preview={false}
              src={user?.image || AvatarDefault}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = AvatarDefault;
              }}
            />
          </Link>
          <div className="user-block-info">
            <div className="user-group">
              <Link to={PATHS.ACCOUNT_PAGE} className="user-name">
                {user?.name}
              </Link>
              {currentPack?.length ? (
                currentPack?.map((pack) => {
                  if (pack?.type === 1 && !isExpired) {
                    return (
                      <div className="user-job" key={pack?.id}>
                        {pack?.status === 1 && pack?.turn > 0 ? (
                          t("remain_package_turn")
                            .replace("_TURN_", pack?.turn)
                            .replace(
                              "_TYPE_",
                              `/ ${
                                PACKAGE_CYCLE[
                                  pack?.pack_id?.split("_")[1]?.toLowerCase()
                                ]
                              }`
                            )
                            .replace(
                              "_BIDS_",
                              `${
                                pack?.turn === 1 ? t("bid.bid") : t("bid.bids")
                              }`
                            )
                        ) : extraBidTotal > 0 ? null : (
                          <Button
                            type="primary"
                            className="buy-bids-button"
                            onClick={handleModal}>
                            {t("bid.buy_more_bids")}
                          </Button>
                        )}
                      </div>
                    );
                  }
                  if (pack?.type === 1 && isExpired && bidTotal === 0) {
                    return (
                      <Button
                        type="primary"
                        className="buy-bids-button"
                        onClick={handleModal}>
                        {t("bid.buy_bids_now")}
                      </Button>
                    );
                  }
                })
              ) : (
                <Button
                  type="primary"
                  className="buy-bids-button"
                  onClick={handleModal}>
                  {t("bid.buy_bids_now")}
                </Button>
              )}
              {extraBidTotal > 0 ? (
                <div className="user-job">
                  {t("remain_extra_turn")
                    .replace("_TURN_", extraBidTotal)
                    .replace(
                      "_BIDS_",
                      `${extraBidTotal === 1 ? t("bid.bid") : t("bid.bids")}`
                    )}
                </div>
              ) : null}
            </div>
          </div>
        </Space>
      </div>
      <ModalChoosePack
        visible={displayModal}
        title={t("bid.buy_subscription")}
        handleClose={handleClose}
        bidTotal={bidTotal}
        packagePackLength={packagePackLength}
      />
    </>
  );
};

export default UserBlock;
